import { render, staticRenderFns } from "./TextSettings.vue?vue&type=template&id=39780dff"
import script from "./TextSettings.vue?vue&type=script&lang=js"
export * from "./TextSettings.vue?vue&type=script&lang=js"
import style0 from "./TextSettings.vue?vue&type=style&index=0&id=39780dff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports